
<script>
    import Cart from "../Cart"
    import OrderHistory from "../../models/OrderHistory"
    import {dateFormat} from "../../utility/dateUtility"
    import CheckoutService from '../../services/CheckoutService'
    import OrderDetailTable from "../order/OrderDetailTable"
    import TooltipQuestion from "../TooltipQuestion"
    import PriceBox from "../PriceBox"

    export default {
        name: 'checkout-confirm',

        data () {
            return {
                disabled: false,
                orderHistory: new OrderHistory(),
                dateFormat,
                CheckoutService,
                isStockCheckOnly: 0,
            }
        },

        props: {
            data:{}
        },

        mounted() {
            this.orderHistory = new OrderHistory({...eval(this.data).order})
            this.isStockCheckOnly = eval(this.data).is_stock_check_only ? 1 : 0
            this.orderHistory.isStockCheckOnly = this.isStockCheckOnly
            this.$nextTick()
        },

        methods: {
            goBack() {
                document.orderConfirmForm.action = '/checkout'
                document.orderConfirmForm['back'].value = true
                document.orderConfirmForm.submit()
            },
            send() {
                try {
                    this.disabled = true
                    document.orderConfirmForm.action = '/checkout'
                    document.orderConfirmForm['is_stock_check_only'].value = !!this.isStockCheckOnly
                    document.orderConfirmForm.submit()
                } catch (e) {

                } finally {
                    this.disabled = false
                }
            }
        },

        components: {
            Cart,
            OrderDetailTable,
            TooltipQuestion,
            PriceBox,
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/checkout/CheckoutConfirm.vue